const PROJECTED_QUERY_PATHS = new Set(['chars', 'systems']);

export const normalizeProjectedViewerContext = (viewerContext) => {
  if (!viewerContext || typeof viewerContext !== 'object' || Array.isArray(viewerContext)) {
    return null;
  }

  if (viewerContext.viewerKind === 'dm') {
    return {
      viewerKind: 'dm',
      viewerCharId: null,
      activeCampaignId: typeof viewerContext.activeCampaignId === 'string' && viewerContext.activeCampaignId.trim()
        ? viewerContext.activeCampaignId.trim()
        : null,
    };
  }

  if (
    viewerContext.viewerKind === 'player'
    && typeof viewerContext.viewerCharId === 'string'
    && viewerContext.viewerCharId.trim()
  ) {
    return {
      viewerKind: 'player',
      viewerCharId: viewerContext.viewerCharId.trim(),
      activeCampaignId: typeof viewerContext.activeCampaignId === 'string' && viewerContext.activeCampaignId.trim()
        ? viewerContext.activeCampaignId.trim()
        : null,
    };
  }

  return null;
};

export const resolveAuthedViewerContext = ({
  serverViewerContext,
  testViewerContext,
}) => {
  const normalizedTestViewerContext = normalizeProjectedViewerContext(testViewerContext);
  if (normalizedTestViewerContext) {
    return normalizedTestViewerContext;
  }
  if (serverViewerContext === undefined) {
    return undefined;
  }
  return normalizeProjectedViewerContext(serverViewerContext);
};

export const shouldBlockAuthedViewerApp = ({
  serverViewerContext,
  testViewerContext,
}) => {
  void serverViewerContext;
  void testViewerContext;
  return false;
};

export const shouldUseProjectedViewerQuery = (path, viewerContext) => (
  PROJECTED_QUERY_PATHS.has(path) && !!viewerContext
);

export const shouldUseAuthedProjectedViewerQuery = (
  path,
  viewerContext,
  useServerDerivedViewerQueries = false,
) => (
  PROJECTED_QUERY_PATHS.has(path) && !!viewerContext && !!useServerDerivedViewerQueries
);

export const buildProjectedViewerQueryArgs = (path, viewerContext) => {
  if (!shouldUseProjectedViewerQuery(path, viewerContext)) return {};
  if (path === 'chars') {
    return {
      viewerKind: viewerContext.viewerKind,
      viewerCharId: viewerContext.viewerKind === 'player' ? viewerContext.viewerCharId : '',
    };
  }
  if (path === 'systems') {
    return { viewerKind: viewerContext.viewerKind };
  }
  return {};
};
